import React from "react";
import { Box, Flex, Image, keyframes, useMediaQuery } from "@chakra-ui/react";
import Wrapper from "../../../common/Wrapper";
import { logos } from "../../../common/constants";

const scrollLogos = keyframes`
 
  50% { transform: translateX(-50%); }
  100% { transform: translateX(-100%); }
`;
// i removed 0% transformationg at the top

const SecondLayer = () => {
  const [isMobile] = useMediaQuery("(max-width: 501px)");

  return (
    <Wrapper>
      <Flex
        pl={["0", "0", "0", "70px"]}
        pr={["0", "0", "0", "70px"]}
        h={["56px", "70px", "160px"]}
        backgroundImage="linear-gradient(#8250CC, #EDC354)"
        pos="relative"
        alignItems="center"
        overflow="hidden"
        whiteSpace="nowrap"
      >
        <Flex
          animation={`${scrollLogos} 10s linear infinite`}
          minW="200%"
          justifyContent="space-between"
          gap={"5px"}
        >
          {logos.concat(logos)?.map((item, i) => (
            <Box key={i}>
              <Image src={item} w={{ base: "100px", md: "150px" }} />
            </Box>
          ))}
        </Flex>
      </Flex>
    </Wrapper>
  );
};

export default SecondLayer;
